import React, { FC } from 'react'
import { classNames, format } from '@dt/fe-utils'
import { restaurantConfig } from '@mobx/mall'
import { ProductImage, BagIcon, Tags } from 'components'
import DiscountTag from '../DiscountTag'
import './index.scss'

interface IProps {
  item: IViewCombinedCartItem | IViewCombinedOrderDetail;
  /** true 待确认 false 已下单 undefined|null 不显示 */
  // isWait?: true | false | undefined | null;
  /** 餐品状态 待下单 待确认 已下单 （无状态） */
  status?: 'WAIT_PLACE' | 'WAIT_CONFRIM' | 'ORDERED' | '';
}

const MultiProductItem: FC<IProps> = ({ item, status }) => {
  const productGroup = (item: IViewCombinedCartItem | IViewCombinedOrderDetail) => {
    return (
      <div className='item-groups'>
        {
          item.productGroups?.map(group => (
            <div key={group.no} className='item-group'>
              {
                group?.productGroupDetails.map(product => (
                  <div key={product.pk} className='item-group-product'>
                    <div className='product-info'>
                      <strong>{product.name}</strong>
                      <br />
                      <small>{product.optionStr}</small>
                      <div className='product-extra-info'>
                        <Tags datas={[...(product.tags || []), ...(product.allergys || [])]} />
                      </div>
                    </div>
                    <div className='product-cnt'>x {product.cnt}</div>
                  </div>
                ))
              }
            </div>
          ))
        }
      </div>
    )
  }
  return (
    <div
      className={classNames('mall-checkout-product-item', {
        'refund-item': (item as IViewCombinedOrderDetail).refundCnt,
        'ordered-item': status === 'ORDERED',
      })}
    >
      <div className='item-top'>
        <ProductImage type='mall' color={!item.pic && restaurantConfig.displayMode === 'waterfall' ? item.productNo : ''} width={64} imgSrc={item.pic} cnt={item.cnt} />
        <div className='item-info'>
          <span className='item-title'>{!!item.isTogo && <BagIcon size='small' />}{item.name}</span>
          <br />
          <small>{item.optionStr}</small>
          <div className='product-extra-info'>
            <Tags datas={[...(item.tags || []), ...(item.allergys || [])]} />
          </div>
        </div>
        <div className='product-price'>
          <div className='price' dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(item.actualPrice) }}></div>
          <div className='item-discount'>
            <DiscountTag offItems={item.offItems} />
          </div>
          {item.actualPrice !== item.totalPrice ? <del dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(item.totalPrice) }}></del> : ''}
        </div>
      </div>
      {productGroup(item)}
      {
        !!status && (
          <div className='item-staus'>
            <span><span>{(item as IViewCombinedOrderDetail).refundCnt ? i18n.t('checkout.refunded') : status === 'WAIT_CONFRIM' ? i18n.t('checkout.unconfirmed') : status === 'ORDERED' ? i18n.t('checkout.ordered') : i18n.t('checkout.unorder')}</span></span>
          </div>
        )
      }
    </div>
  )
}

export default MultiProductItem
